<script>
import Teams from "@/services/Teams";
import Swal from "sweetalert2";
import Fixtures from "../../../services/Fixtures";

export default {
  props: {
    match_id: String,
    lineupHome: Array,
    lineupAway: Array,
  },
  emits: ["response"],
  data() {
    return {
      csrf_token: localStorage.getItem("csrf_token"),
      showModal: false,
      tryingToEdit: false,
      match_minute: null,
      player_id: null,
      competition_id: process.env.VUE_APP_COMPETITION_ID,
      matchesPerRound: [],
      competitionRounds: [],
      tryingToSubmit: false,
    };
  },
  computed: {
    players() {
      return this.lineupAway.concat(this.lineupHome);

    },
    
  },
  // mounted() {
  //     this.getCompetitionRounds();
  // },
  methods: {
    //this.tryingtosubmit

    async addMOTM() {
      try {
        this.tryingToSubmit = true;
        const response = await Fixtures.addMOTM(
          this.match_id,  
          this.player_id,
        );
        // this.$emit("response", this.team_id);
        this.successmsg();
        this.tryingToSubmit = false;
        this.closeModal();
        console.log(response);
      } catch (error) {
        this.failedmsg(error.response.data.error);
        this.tryingToSubmit = false;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    closeModal() {
      this.showModal = false;
    },

    successmsg() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Change has been saved",
        showConfirmButton: false,
        timer: 2000,
      });
    },

    failedmsg(msg) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: msg,
        showConfirmButton: false,
        timer: 50000,
      });
    },
  },
};
</script>

<template>
  <b-modal
    id="motm"
    v-model="showModal"
    title="Man Of The Match"
    title-class="text-black font-18"
    body-class="p-3"
    hide-footer
    centered
  >
    <form @submit.prevent="addMOTM">
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label class="control-label form-label">Choose Player</label>
            <select
              v-model="player_id"
              class="form-control form-select"
              name="player_id"
              type="select"
            >
              <b-form-select-option :value="null"
                >Please select a player</b-form-select-option
              >
              <option
                v-for="player in players"
                :key="player.player_id"
                :value="player.player_id"
              >
                {{ player.player_name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="text-end pt-5 mt-3">
        <b-button variant="light" @click="closeModal">Close</b-button>
        <b-button
          type="submit"
          variant="primary"
          class="ms-3"
          @click="$emit('response', team_id)"
        >
          {{ this.tryingToSubmit ? "Loading..." : "Submit" }}
        </b-button>
      </div>
      <input type="hidden" name="csrf_token" v-model="csrf_token" />
    </form>
  </b-modal>
</template>
